import script from "./AnalyticsBrief.vue?vue&type=script&setup=true&lang=js"
export * from "./AnalyticsBrief.vue?vue&type=script&setup=true&lang=js"

import "./AnalyticsBrief.vue?vue&type=style&index=0&id=d0233ff2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0233ff2"]])

export default __exports__